<template>
  <v-dialog v-model="show" fullscreen persistent @keydown.esc="hide">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" text :loading="loading">
        {{ text }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        <span class="title text--secondary">
          {{ title }} {{ $t("instructions.title").toUpperCase() }}
        </span>
        <v-spacer />
        <v-btn icon @click="hide"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <instructions-table
        :instructions="instructions"
        :canEdit="false"
        :loading="loading"
        :showActiveCounts="true"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import InstructionsTable from "@/components/instruction/InstructionsTable.vue";

export default {
  props: ["text", "instructions", "title", "loading"],
  components: {
    InstructionsTable,
  },
  data() {
    return {
      show: false,
    };
  },
  mounted() {},
  computed: {},
  methods: {
    hide() {
      this.show = false;
    },
  },
};
</script>
